import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';

@Component({
    selector: 'confirm-child-demographic-save',
    templateUrl: './confirm-child-demographic-save.component.html',
    styleUrls: ['./confirm-child-demographic-save.component.scss']
})
export class ConfirmChildDemographicSaveComponent implements OnInit {
    msg: string;
    tableDataSources: MatTableDataSource<any>[] = [];
    hasChanges: boolean = false;
    isLoading: boolean = false;

    displayedColumns: string[] = ['CHANGED_FIELD', 'VALUE', 'CHANGED_VALUE'];

    constructor(public dialogRef: MatDialogRef<ConfirmChildDemographicSaveComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

    ngOnInit(): void {
        this.isLoading = true;
        this.updateDataSource();
        this.isLoading = false;
    }

    submit() {
        this.closeDialog(true);
    }

    openDialog(): void {}

    closeDialog(confirmed: boolean) {
        let data = { confirmed: confirmed };
        this.dialogRef.close(data);
    }

    updateDataSource() {
        this.tableDataSources = [];

        this.data.CATEGORIES.forEach((category: any, index: number) => {
            let datasource = new MatTableDataSource<any>();
            datasource.data = category.CHANGES;

            if (category.CHANGES.length > 0) {
                this.hasChanges = true;
            }

            this.tableDataSources.push(datasource);
        });
    }
}
